document.addEventListener('DOMContentLoaded',()=>{

  const nav=document.querySelector('.t_n')

  if(!nav)return

  const SEARCH_CANDIDATES=[
    '[data-drawer-toggle="search"]',
    '[data-action="open-drawer"][data-drawer-id="search"]',
    '[data-open-search]',
    '.header__icon--search',
    'button[aria-controls="SearchDrawer"]',
    '#SearchDrawer',
    '#search-drawer',
    '.js-search-drawer-open',
  ]

  const CART_CANDIDATES=[
    '[data-drawer-toggle="cart"]',
    '[data-action="open-drawer"][data-drawer-id="cart"]',
    '[data-cart-toggle]',
    '.header__icon--cart',
    'button[aria-controls="CartDrawer"]',
    '#CartDrawer',
    '#cart-drawer',
    '.js-drawer-open-cart',
  ]

  const SEARCH_ELEMENTS=SEARCH_CANDIDATES
    .map(selector=>{

      try{
        return document.querySelector(selector)
      }catch(error){
        return null
      }

    })
    .filter(Boolean)

  const CART_ELEMENTS=CART_CANDIDATES
    .map(selector=>{

      try{
        return document.querySelector(selector)
      }catch(error){
        return null
      }

    })
    .filter(Boolean)

  const tryOpen=(elements)=>{

    for(const el of elements){

      el.dispatchEvent(
        new Event('click',{bubbles:true})
      )

      return true

    }

    return false

  }

  const openSearch=(e)=>{

    e.preventDefault()

    if(!tryOpen(SEARCH_ELEMENTS)){
      window.location.href='/search'
    }

  }

  const openCart=(e)=>{

    e.preventDefault()

    if(!tryOpen(CART_ELEMENTS)){
      window.location.href='/cart'
    }

  }

  nav.addEventListener('click',(e)=>{

    const searchTrigger=e.target.closest('[data-t_n-open="search"]')
    const cartTrigger=e.target.closest('[data-t_n-open="cart"]')

    if(searchTrigger){
      openSearch(e)
      return
    }

    if(cartTrigger){
      openCart(e)
      return
    }

  })

  const desktop=nav.querySelector('.t_n__desktop')

  const desktopTriggers=[
    ...nav.querySelectorAll('[data-nav-trigger]')
  ]

  const desktopPanels=[
    ...nav.querySelectorAll('[data-nav-panel]')
  ]

  const mobileToggle=nav.querySelector('[data-mobile-toggle]')
  const mobileDrawer=nav.querySelector('.t_n__mobile_drawer')

  const mobilePanels=[
    ...nav.querySelectorAll('[data-mobile-panel]')
  ]

  let activeMobilePanel='root'

  let activeDesktop=null
  let desktopTimeout=null

  const closeDesktop=()=>{

    for(const panel of desktopPanels){
      panel.classList.remove('is-active')
    }

    for(const trigger of desktopTriggers){
      trigger.classList.remove('is-active')
    }

    activeDesktop=null

  }

  const setActiveDesktop=(target)=>{

    if(activeDesktop===target)return

    activeDesktop=target

    for(const trigger of desktopTriggers){

      trigger.classList.toggle(
        'is-active',
        trigger.dataset.target===target
      )

    }

    for(const panel of desktopPanels){

      panel.classList.toggle(
        'is-active',
        panel.dataset.navPanel===target
      )

    }

  }

  if(desktop){

    desktop.addEventListener('mouseover',(e)=>{

      const trigger=e.target.closest('[data-nav-trigger]')

      if(!trigger)return

      clearTimeout(desktopTimeout)

      setActiveDesktop(trigger.dataset.target)

    })

    desktop.addEventListener('mouseleave',()=>{

      desktopTimeout=setTimeout(()=>{
        closeDesktop()
      },120)

    })

  }

  const setMobilePanel=(target)=>{

    activeMobilePanel=target

    for(const panel of mobilePanels){

      const panelId=panel.dataset.mobilePanel

      panel.classList.remove(
        'is-active',
        'is-prev'
      )

      if(panelId===target){
        panel.classList.add('is-active')
      }

      else if(panelId==='root'){
        panel.classList.add('is-prev')
      }

    }

  }

  if(mobileToggle&&mobileDrawer){

    mobileToggle.addEventListener('click',()=>{

      const isOpen=mobileDrawer.classList.contains('is-active')

      const nextState=!isOpen

      if(isOpen){
        setMobilePanel('root')
      }

      mobileDrawer.classList.toggle('is-active')

      mobileToggle.classList.toggle('is-active')

      mobileToggle.setAttribute(
        'aria-expanded',
        nextState
      )

      mobileDrawer.setAttribute(
        'aria-hidden',
        !nextState
      )

      document.documentElement.classList.toggle(
        't_n__lock',
        !isOpen
      )

      document.body.classList.toggle(
        't_n__lock',
        !isOpen
      )

    })

  }

  nav.addEventListener('click',(e)=>{

    const nextButton=e.target.closest('[data-mobile-next]')
    const backButton=e.target.closest('[data-mobile-back]')

    if(nextButton){

      setMobilePanel(
        nextButton.dataset.mobileNext
      )

    }

    if(backButton){

      setMobilePanel('root')

    }

  })

  const topbarTrack=nav.querySelector('.t_n__topbar_track')

  if(topbarTrack){

    const topbarItems=[
      ...topbarTrack.querySelectorAll('.t_n__topbar_item')
    ]

    if(topbarItems.length>1){

      let activeIndex=0

      const updateTopbar=()=>{

        topbarTrack.style.transform=
          `translateX(-${activeIndex * 100}%)`

      }

      const topbarInterval=setInterval(()=>{

        activeIndex++

        if(activeIndex>=topbarItems.length){
            activeIndex=0
        }

        updateTopbar()

        },4000)

        window.addEventListener('beforeunload',()=>{

        clearInterval(topbarInterval)

        })

    }

  }

  const updateCartCount=async()=>{

    try{

      const response=await fetch('/cart.js')
      const cart=await response.json()

      const counts=[
        ...document.querySelectorAll('[data-cart-count]')
      ]

      for(const count of counts){

        count.textContent=cart.item_count

        count.classList.toggle(
          'is-hidden',
          cart.item_count < 1
        )

      }

    }catch(error){
    console.warn(error)
    }

  }

  document.addEventListener(
    'cart:refresh',
    updateCartCount
  )

  document.addEventListener(
    'cart:updated',
    updateCartCount
  )

  document.addEventListener(
    'ajaxProduct:added',
    updateCartCount
  )

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      updateCartCount()
    }
  })

  updateCartCount()

  document.addEventListener('keydown',(e)=>{

  if(e.key!=='Escape')return

  if(mobileDrawer&&mobileToggle){

    mobileDrawer.classList.remove('is-active')

    mobileToggle.classList.remove('is-active')

    mobileToggle.setAttribute(
      'aria-expanded',
      'false'
    )

    mobileDrawer.setAttribute(
      'aria-hidden',
      'true'
    )

  }

  document.documentElement.classList.remove(
    't_n__lock'
  )

  document.body.classList.remove(
    't_n__lock'
  )

  setMobilePanel('root')

  closeDesktop()

  })

})

document.querySelectorAll('[data-nav-close]').forEach((item) => {
  item.addEventListener('mouseenter', () => {
    document.querySelectorAll('[data-nav-panel]').forEach((panel) => {
      panel.classList.remove('is-active');
    });

    document.querySelectorAll('[data-nav-trigger]').forEach((trigger) => {
      trigger.classList.remove('is-active');
    });
  });
});